export class ArticleTypeIds {
  public static readonly BRIDGE = 2;
  public static readonly LABELING = 5;
  public static readonly N_BUSBAR = 8;
  public static readonly END_PLATE = 1;
  public static readonly MULTI_CONNECTORS = 11;
  public static readonly END_STOP = 12;
  public static readonly END_TERMINAL = 12;
  public static readonly TERMINAL_BLOCK = 13;
  public static readonly PCB_TERMINAL_BLOCKS = 14;
  public static readonly TRANSFORMER_TERMINAL_BLOCK = 18;
  public static readonly DEFAULT_TERMINAL = 15;
  public static readonly COVER = 21;
  public static readonly WIRE_FERRULE = 22;
  public static readonly WIRE_BRIDGE = 23;
  public static readonly MODULE_INSERT = 25;
  public static readonly WIREBRIDGE = 23;
  public static readonly IO_ARTICLE = 31;
  public static readonly INTERFACE_MODULES = 32;
  public static readonly MALE_HEADER_FOR_PCB = 33;
  public static readonly MARKER_CARRIER = 34;
  public static readonly MCS_GDS_END_PLATE = 35;
  public static readonly CODING_FINGER = 50;
  public static readonly SNAPIN_CODING_FINGER = 52;
  public static readonly RAIL_ACCESSORY = 89;
  public static readonly CUSTOM_ARTICLE = 90;
  public static readonly EMPTY_ZONE = 91;
  public static readonly CABLE = 93;
  public static readonly DRILLING_HOLE = 96;
  public static readonly BLOCKING_ZONE = 97;
  public static readonly GENERAL_ACCESSORIES = 99;
  public static readonly MOUNTING_RAIL = 10;
  public static readonly LTL = 26;

  public static readonly ORDERED_TYPE_LIST: number[] = [
    ArticleTypeIds.TERMINAL_BLOCK,
    ArticleTypeIds.DEFAULT_TERMINAL,
    ArticleTypeIds.END_TERMINAL,
    ArticleTypeIds.END_PLATE,
    ArticleTypeIds.IO_ARTICLE,
    ArticleTypeIds.LABELING,
    ArticleTypeIds.BRIDGE,
    ArticleTypeIds.WIREBRIDGE,
    ArticleTypeIds.CUSTOM_ARTICLE
  ];

}
